export const toiCitys = [
    {
     "TOI_City_List": "Patna"
    },
    {
     "TOI_City_List": "Jaipur"
    },
    {
     "TOI_City_List": "Indore"
    },
    {
     "TOI_City_List": "Pune"
    },
    {
     "TOI_City_List": "Lucknow"
    },
    {
     "TOI_City_List": "Vadodara"
    },
    {
     "TOI_City_List": "Bengaluru"
    },
    {
     "TOI_City_List": "Gurgaon"
    },
    {
     "TOI_City_List": "Jalandhar"
    },
    {
     "TOI_City_List": "Bhubaneshwar"
    },
    {
     "TOI_City_List": "Meerut"
    },
    {
     "TOI_City_List": "Bhopal"
    },
    {
     "TOI_City_List": "Kanpur"
    },
    {
     "TOI_City_List": "Varanasi"
    },
    {
     "TOI_City_List": "Coimbatore"
    },
    {
     "TOI_City_List": "Chennai"
    },
    {
     "TOI_City_List": "Kolkata"
    },
    {
     "TOI_City_List": "Mumbai"
    },
    {
     "TOI_City_List": "Ahmedabad"
    },
    {
     "TOI_City_List": "Noida"
    },
    {
     "TOI_City_List": "Kochi"
    }
   ]